import React from 'react';
import './FactionRatmenDescription.css';
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {FARM_SUPPLY_STANDARD_COUNT} from "../../../../constants/supply";
import {
  RATMEN_MELEE_COMBAT_BONUS_PER_ALLY,
  RATMEN_SIZE_FOR_ADDITIONAL_SUPPLY
} from "../../../../configs/factions/ratmen";

const FactionRatmenDescription = () => {
  const supplyNoMargin = <img
    className={'policy-description-icon'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;
  const farmSupply1ValueAndIcon = <DescriptionValueWithIcon
    className={'text-supply policy-description-icon-margin-left-end'}
    value={FARM_SUPPLY_STANDARD_COUNT}
    icon={supplyNoMargin}
  />;

  const unitD6 = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд Пехота'}
    title={'Отряд Пехота (макс. размер 6)'}
  />

  // Пехота крысолюдов перечисляется поштучно: прирост за дополнительное
  // снабжение получает только она (d6/d10/d20), но не катапульты и кавалерия
  const unitD6MarginLeft = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд Пехота'}
    title={'Отряд Пехота (макс. размер 6)'}
  />
  const unitD10 = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-left'}
    src={'/img/icons/unit d10 friend.png'}
    alt={'Отряд Тяжёлая пехота'}
    title={'Отряд Тяжёлая пехота (макс. размер 10)'}
  />
  const unitD20 = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d20 friend.png'}
    alt={'Отряд Элитная пехота'}
    title={'Отряд Элитная пехота (макс. размер 20)'}
  />

  const unitSize = <img
    className={'policy-description-icon'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда'}
  />;

  // const sizeSD6ValueAndIcon = <DescriptionValueWithIcon
  //   value={'S/6'}
  //   icon={unitSize}
  // />

  const farmMarginLeft = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/farm.699e6dfc.png'}
    alt={'Ферма'}
    title={'Ферма'}
  />;

  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-left-end'}
    src={'/img/icons/supply.png'}
    alt={'Снабжение'}
    title={'Снабжение'}
  />;

  const sizeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={`+${RATMEN_SIZE_FOR_ADDITIONAL_SUPPLY}`}
    icon={unitSize}
  />


  const damageBonus = <span className={'text-war'}>
    {`+${RATMEN_MELEE_COMBAT_BONUS_PER_ALLY}`}
  </span>;
  const damage = <img
    className={'policy-description-icon'}
    src={'/img/icons/damage.png'}
    alt={'Урон'}
    title={'Урон'}
  />;
  const melee = <img
    className={'policy-description-icon'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const damageBonusValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-left-end'}
    value={damageBonus}
    icon={<>{damage}{melee}</>}
  />

  return (
    <>
      <div className="policy-description_line">
        В
        <span className={'text-supply policy-description-icon-margin-right-left'}>
          фазе Снабжения
        </span>
        можно за {farmSupply1ValueAndIcon}
      </div>
      <div className="policy-description_line">
        нанять обычную Пехоту {unitD6} на {farmMarginLeft}.
      </div>

      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        Если пехота {unitD6MarginLeft}{unitD10}{unitD20} получает
      </div>
      <div className="policy-description_line">
        дополнительное {supply}, то получает {sizeValueAndIcon}.
      </div>

      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        Все отряды получают {damageBonusValueAndIcon}
      </div>
      <div className="policy-description_line">
        за каждый смежный <span className={'text-success policy-description-icon-unit-margin-right-left'}>союзный</span> отряд.
      </div>
    </>
  );
};

export default FactionRatmenDescription;
